import axios from "axios"

const token = localStorage.getItem('token');

// Update the API base URL to match your Flask backend port
const api = axios.create({
  baseURL: 'https://new-thriftshop.onrender.com/api',
  headers: {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  }
});

// Add a request interceptor to include the token in the headers
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token")
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.error("API Error:", error.response?.data || error.message)
    return Promise.reject(error)
  },
)

export default api;export const getAllProducts = async () => {
  return await api.get("/products");
};

export const getProductById = async (id: number) => {
  return await api.get(`/products/${id}`);
};

export const createProduct = async (formData: FormData) => {
  return await api.post("/products", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateProduct = async (id: number, formData: FormData) => {
  return await api.put(`/products/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteProduct = async (id: number) => {
  return await api.delete(`/products/${id}`);
};

export const getMyProducts = async () => {
  return await api.get("/products/my-products");
};

export const createTransaction = async (productId: number) => {
  return await api.post("/transactions", { product_id: productId });
};

export const fetchTransactions = async () => {
  return await api.get("/transactions/");
};

export const confirmTransaction = async (transactionId: number) => {
  return await api.put(`/transactions/${transactionId}/confirm`);
};

export const generateTransactionReport = async (transactionId: number) => {
  return await api.get(`/transactions/${transactionId}/report`, {
    responseType: 'blob', // for downloading PDF
  });
};

export const submitFeedback = async (
  transactionId: number,
  rating: number,
  comment: string
) => {
  return await api.post("/feedback", {
    transaction_id: transactionId,
    rating,
    comment
  });
};

export const getProfile = () => api.get("/profile/");

export const updateProfile = (formData: FormData) =>
  api.put("/profile/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const deleteProfile = () => api.delete("/profile/");

export const fetchAllSellers = async () => {
  return await api.get("/dashboard/sellers/");
};

export const fetchAllFeedback = async () => {
  return await api.get("/dashboard/feedback/");
};

export const fetchAllProducts = async () => {
  return await api.get("/dashboard/products/");
};


// Admin: Get all products for a user
export const getUserProducts = async (userId: number) => {
  return await api.get(`/admin/users/${userId}/products`);
};

// Admin: Get all feedbacks involving a user
export const getUserFeedbacks = async (userId: number) => {
  return await api.get(`/admin/users/${userId}/feedbacks`);
};

// Admin: Get all transactions involving a user
export const getUserTransactions = async (userId: number) => {
  return await api.get(`/admin/users/${userId}/transactions`);
};

// Admin: Delete a user account
export const deleteUserByAdmin = async (userId: number) => {
  return await api.delete(`/admin/users/${userId}`);
};

// Admin: Get full user details (profile, feedbacks, products, transactions)
export const getUserDetails = async (userId: number) => {
  return await api.get(`/admin/users/${userId}`);
};

// Admin: Delete a user by ID
export const deleteUserAccount = async (userId: number) => {
  return await api.delete(`/admin/users/${userId}`);
};

